<template>
  <div class="paginaFinal">
    <h4>Seu arquivo foi enviado com sucesso, Obrigado!!</h4>
  </div>
</template>

<script>
export default {};
</script>

<style>
.paginaFinal {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
</style>